<template>
  <div>
    <div ref="bar" id="bar" style="height:300px;width:600px" v-show="false"></div>
    <div class="dialog" v-if="isInfo">
      <div class="title">测评简介及目的</div>
      <div class="msg">
        <p v-if="topicinfo.description">{{topicinfo.description}}</p>
        <p v-if="topicinfo.purpose">{{topicinfo.purpose}}</p>
      </div>
      <l-button value="开始测评" color="#3170FF" @click.native="isInfo=false,getTime()" />
    </div>
    <!--  -->
    <div class="top">
      <l-navTop></l-navTop>
      <p class="title">{{topicinfo.title}}</p>
      <p class="time">正在答题：{{ timeFormat(time) }}</p>
      <l-button value="退出测评" @click.native="setIncompleteData(true);$router.back()" />
    </div>
    <div class="wrap">
      <div class="left">
        <div v-for="(item,index) in topicList" :key="item.id" v-show="index==topicId">
          <p class="topic">{{index+1}}、{{item.question}} [单选题]</p>
          <ul>
            <li
              v-for="(answer,index) in item.answers"
              :key="index"
              @click="activeAnswer(answer,index)"
              :style="{'backgroundColor': (answerIndex[topicId] == index ? topicColor[index%topicColor.length] : '')}"
            >{{answer.option_answer}}</li>
          </ul>
        </div>
        <div class="jump">
          <l-button value="上一题" color="#3170FF" @click.native="prev()" />
          <l-button value="下一题" @click.native="next()" />
          <p>
            <el-checkbox v-model="isAuto"></el-checkbox>答题后自动跳到下一题
          </p>
          <l-button value="提交" color="#3170FF" @click.native="handSub()" />
        </div>
      </div>
      <div class="right">
        <p>答题卡</p>
        <ul>
          <li
            v-for="(item,index) in topicList.length"
            :key="index"
            @click="jumpTopic(index)"
            :class="answerIndex[index] >= 0 ? 'activeli' : ''"
          >{{index+1}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import lNavTop from "../../../components/lNavTop.vue";
import lButton from "../../../components/lButton.vue";
let bar;
export default {
  data() {
    return {
      time: 0,
      timer: null,
      shake: false,
      isAuto: false,
      isInfo: true,
      topicList: [],
      topicinfo: {},
      topicId: 0,
      topicColor: [
        "rgba(255,105,180,0.5)",
        "rgba(123,104,238,0.5)",
        "rgba(221,160,221,0.5)",
        "rgba(100,149,237,0.5)",
        "rgba(255,165,0,0.5)",
        "rgba(60,179,113,0.5)",
      ],
      answerIndex: [],
      questionScore: [], //题目、分数合集
      recordid: "", //获取结果id
      record: {},
      base64: "",

    };
  },
  methods: {
    //获取题目
    async getTopic() {
      let { data } = await this.$post("api/test/subTableById", {
        id: this.$route.query.id,
        publishId: this.$route.query.publishId,
      });
      this.topicList = data.data.list;
      this.topicinfo = data.data.Info[0];
      this.answerIndex = Array.from({ length: this.topicList.length }, () => {
        return -1;
      });

      this.getIncompleteData()
    },
    //上一题
    prev() {
      if (this.topicId == 0) {
        return;
      }
      this.topicId--;
    },
    //下一题
    next() {
      if (this.topicId == this.topicList.length - 1) {
        return;
      }
      this.topicId++;
    },
    //答题卡跳题
    jumpTopic(index) {
      this.topicId = index;
    },
    //选择答案
    activeAnswer(item, index) {
      this.$set(this.answerIndex, this.topicId, index);
      if (this.shake) return;
      if (this.isAuto && this.topicId < this.topicList.length - 1) {
        this.shake = true;
        setTimeout(() => {
          this.topicId++;
          this.shake = false;
        }, 200);
      }
      let obj = { question_id: this.topicId + 1, score: item.option_score };
      this.$set(this.questionScore, this.topicId, obj);

      this.setIncompleteData()
    },
    //提交答案
    handSub() {
      // console.log(this.topicList)
      // console.log(this.answerIndex)
      let isAllAnswer = this.answerIndex.some(item => {
        return item < 0
      })
      if (isAllAnswer) {
        this.$myMessage("还有题目没有回答，请查看答题卡");
        return
      }
      
      this.$popup({
        title: '提示',
        content: '是否提交本次测评结果？',
        saveFoo: () => {
          clearInterval(this.timer);
          this.setIncompleteData(true)
          this.$post("api/test/commitTableResult", {
            id: this.$route.query.id,
            publishId: this.$route.query.publishId,
            questionScore: this.questionScore,
            seconds: this.timeFormat(this.time),
            is_interaction: 0,
          }).then(async (res) => {
            if (res.data.code == 0) {
              this.recordid = res.data.data.recordId;
              console.log(JSON.parse(res.data.data.result))
              // this.$post("api/test/commitTeam", {
              //   id: this.$route.query.id,
              //   publishId: this.$route.query.publishId,
              //   questionScore: this.questionScore,
              //   seconds: this.timeFormat(this.time),
              // });
              try {
                //提交用户答题次数
                this.$getUserNum(1);
                //提交用户答题记录
                // let { data } = await this.$post("api/test/getResultScale", {
                //   recordid: this.recordid,
                // });
                // let result = data.data.data.recordInfo.recordResult;
                // this.record = result.map((item) => {
                //   return [item.gradeName, item.scores];
                // });

                let resultObj = JSON.parse(res.data.data.result)
                console.log(resultObj)

                let resultCategory = []
                for (let key in resultObj.resultCategory) {
                  resultCategory.push(resultObj.resultCategory[key])
                }
                resultObj.resultCategory = resultCategory
                
                let result = resultObj.resultCategory.map((item) => {
                  return [item.categoryName, item.categoryScores];
                });
                this.record = result
                await this.handEcharts();
                console.log(this.base64)
                this.$post("api/test/getRecordImage", {
                  testType: this.$route.query.testType,
                  recordId: this.recordid,
                  img: this.base64,
                });

                let html = "";
                result.forEach((item) => {
                  html += `<div><h3>${item.degree}</h3><p>分数：${item.scores}</p><p>${item.result}</p></div>`;
                });
                let base64 =
                  "data:image/png;base64,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";
                this.$addUserRecord(
                  "量表测评",
                  "",
                  `<div class="box"><img src="${base64}"><p>测评量表：${this.topicinfo.title}</p></div>`,
                  `<div><img src="${this.base64}"></div>${html}`
                );
              } catch (error) {
                console.log(error)
              }
              this.$router.back();
            }
          });
        },
      })
      // this.$myMessage("提交");
      // return
    },
    //echarts
    handEcharts() {
      //销毁echarts实例
      if (bar) {
        bar.dispose();
      }
      bar = this.echarts.init(this.$refs.bar);
      let colors = ['#0AA7F4','#ED6942','#F29EC2','#36D5E5','#12B5B0','#F9B552','#e91e63','#f44336','#EEAD0E','#E066FF','#B3EE3A'];
      let option = {
        backgroundColor: "#fff",
        animation: false,
        grid: {
          top: "30",
          left: "40",
          right: "50",
          bottom: "60",
        },
        xAxis: {
          type: "category",
          //data: Array.from({ length: this.record.length }, (x, i) => x + i),
          axisLine: {
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 7], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: true, //---是否显示
            inside: true, //---是否朝内
            lengt: 2, //---长度
            lineStyle: {
              //color:'red',			//---默认取轴线的颜色
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 30,
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            symbol: ["none", "arrow"], //---是否显示轴线箭头
            symbolSize: [8, 8], //---箭头大小
            symbolOffset: [0, 10], //---箭头位置
            lineStyle: {
              color: "rgba(51,51,51,0.5)",
            },
          },
          axisTick: {
            //---坐标轴 刻度
            show: false, //---是否显示
          },
          splitLine: {
            //---grid 区域中的分隔线
            show: true, //---是否显示，'category'类目轴不显示，此时我的X轴为类目轴，splitLine属性是无意义的
            lineStyle: {
              color: "#404040",
              opacity: "0.2",
              width: 1,
              type: "dashed",
            },
          },
          axisLabel: {
            color: "#404040", //更改坐标轴文字颜色
            fontWeight: 100,
          },
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              //---图形形状
              borderRadius: [5, 5, 0, 0],
              color: function (params) {
                return colors[params.dataIndex % colors.length];
              },
            },
            barWidth: 20, //---柱形宽度
            // barCategoryGap: "20%", //---柱形间距
            data: this.record,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      bar.setOption(option);
      //导出echarts
      var opts = {
        //type: "jpeg", // 导出的格式，可选 png, jpeg
        pixelRatio: 1, // 导出的图片分辨率比例，默认为 1。
        //backgroundColor: "#fff", // 导出的图片背景色，默认使用 option 里的 backgroundColor
      };
      this.base64 = bar.getDataURL(opts); //拿到base64 地址
      window.addEventListener("resize", function () {
        bar.resize();
      });
    },
    //答题时间
    getTime() {
      this.timer = setInterval(() => {
        this.time += 1;
      }, 1000);
    },
    timeFormat (time) {
      let hour = Math.floor(time / (60 * 60)); //小时
      let min = Math.floor((time / 60) % 60); //分钟
      let sec = Math.floor(time % 60); //秒
      hour = hour < 10 ? '0' + hour : hour;
      min = min < 10 ? '0' + min : min;
      sec = sec < 10 ? '0' + sec : sec;
      return `${hour}:${min}:${sec}`;
    },

    //===================================
    // 做题时储存当前已完成结果，防止意外退出导致结果丢失
    setIncompleteData (isDel = false) {
      let jsonsData = localStorage.getItem('incompleteData')
      let nowUid = JSON.parse(localStorage.getItem('userinfo'))?.uid ?? ''
      let dataList = []
      if (jsonsData) {
        dataList = JSON.parse(jsonsData)
        let fIndex = dataList.findIndex((item)=>{
          return item.uid == nowUid
            && item.type == 'scale'
            && item.id == this.$route.query.id
            && item.publishId == this.$route.query.publishId
        })
        if (fIndex > -1) {
          dataList.splice(fIndex, 1)
        }
      }
      if (!isDel) {
        dataList.push({
          uid: nowUid,
          type: 'scale',
          id: this.$route.query.id,
          publishId: this.$route.query.publishId,
          answerIndex: this.answerIndex,
          questionScore: this.questionScore,
          time: this.time,
          cDate: new Date().getTime()
        })
      }
      localStorage.setItem('incompleteData', JSON.stringify(dataList));
    },
    getIncompleteData () {
      let jsonsData = localStorage.getItem('incompleteData')
      let nowUid = JSON.parse(localStorage.getItem('userinfo'))?.uid ?? ''
      if (jsonsData) {
        let dataList = JSON.parse(jsonsData)

        // 清除过期数据
        let nowDate = new Date().getTime()
        for (let i = 0; i < dataList.length; i++) {
          if (nowDate - dataList[i].cDate > (24 * 60 * 60 * 1000)) { // 最多24小时
            dataList.splice(i, 1)
          }
        }
        localStorage.setItem('incompleteData', JSON.stringify(dataList));

        let fIndex = dataList.findIndex((item)=>{
          return item.uid == nowUid
            && item.type == 'scale'
            && item.id == this.$route.query.id
            && item.publishId == this.$route.query.publishId
        })
        if (fIndex > -1) {
          let itemObj = dataList[fIndex]
          this.answerIndex = itemObj.answerIndex
          this.questionScore = itemObj.questionScore
          this.time = itemObj.time
        }
      }
    },


  },
  created () {
  },
  mounted() {
    this.getTopic();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  components: {
    lNavTop,
    lButton,
  },
};
</script>

<style lang="less" scoped>
.dialog {
  width: 1000px;
  height: 730px;
  border-radius: 16px;
  box-shadow: 0px 0px 10px 0px rgba(13, 4, 9, 0.2);
  position: absolute;
  top: 210px;
  left: 25%;
  background: #ffffff;
  overflow: hidden;
  text-align: center;
  z-index: 99;
  .title {
    background: #3170ff;
    height: 50px;
    color: #fff;
    font-size: 20px;
    line-height: 50px;
  }
  .msg {
    font-size: 14px;
    color: #333333;
    padding: 62px 75px 0 75px;
    margin-bottom: 25px;
    height: 520px;
    text-align: justify;
    text-indent: 2em;
    line-height: 28px;
    overflow: auto;
  }
  button {
    width: 130px;
  }
}
.top {
  background: #3831ff;
  //width: 1920px;
  height: 370px;
  text-align: center;
  color: #fff;
  .title {
    font-size: 22px;
    margin: 97px 0 32px 0;
  }
  .time {
    font-size: 18px;
    margin-bottom: 31px;
  }
  button {
    width: 145px;
  }
}
.wrap {
  display: flex;
  height: 710px;
  .left {
    width: 1245px;
    border-right: 1px solid #f0f0f0;
    color: #505050;
    box-sizing: border-box;
    padding: 56px 0 0 394px;
    overflow-y: auto;
    .topic {
      margin-bottom: 40px;
    }
    li {
      // height: 50px;
      width: 750px;
      background: rgba(240, 240, 240, 0.6);
      // line-height: 50px;
      margin-bottom: 20px;
      font-size: 15px;
      padding-left: 20px;
      box-sizing: border-box;
      border-radius: 10px;

      padding-top: 10px;
      padding-bottom: 10px;
      line-height: 30px;
    }
    .jump {
      display: flex;
      align-items: center;
      margin-top: 50px;
      button {
        height: 46px;
        width: 90px;
        margin: 0 9px;
      }
      p {
        margin-left: 26px;
        .el-checkbox {
          margin-right: 10px;
        }
      }
    }
  }
  .right {
    p {
      margin: 24px 0 29px 164px;
      color: #222222;
    }
    ul {
      width: 350px;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      margin-left: 48px;
      height: 550px;
      overflow: auto;
    }
    li {
      width: 40px;
      height: 40px;
      color: #333333;
      border: 1px solid #d8d8d8;
      border-radius: 4px;
      text-align: center;
      line-height: 40px;
      margin: 0 20px 20px 0;
    }
    .activeli {
      background: #3170ff;
      color: #ffffff;
    }
  }
}
</style>